import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import styled from 'styled-components';
import { connect } from 'react-redux';
import QRCanvas, { CanvasHelper } from 'admin/components/shared/QRCanvas';
import Message from 'admin/components/shared/QRCanvas/Message';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import Button from 'admin/components/shared/Button';
import _LabeledSelect from 'admin/components/molecules/LabeledSelect';
import Label from 'admin/components/atoms/Label';
import Select from 'admin/components/atoms/Select';
import { setShop } from 'admin/actions/qr-design-viewer';
import { getQRDesign } from 'admin/actions/qr-designer';
import { createBill } from 'admin/actions/bills';
import { fetchOrganizations } from 'admin/actions/organization';
import { fetchShops } from 'admin/actions/shops';
import { openAlertModal } from 'admin/actions/alert-modal';
import { toQueryParams } from 'admin/utils';
import styles from './styles.scss';
import Picker from './Picker';
import { SIZE_TABLE } from 'admin/constants/qr-designer';
import SelectedPrivateMoneyDisplay from '../../organisms/SelectedPrivateMoneyDisplay';

const LabeledSelect = styled(_LabeledSelect)`
  padding: 5px;
  ${Select} {
    width: 300px;
  }
  ${Label} {
    width: 70px;
  }
`;

const LabelText = styled.span`
  font-weight: 600;
`;

class ShopQRDesign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationOptions: [],
      selectedOrganizationOption: null,
      shopOptions: [],
      selectedShopOption: null,
    };
  }
  componentDidMount() {
    this.handleSelectMoney(this.props.userPrivateMoney);
  }

  componentDidUpdate(prevProps) {
    if (this.props.userPrivateMoney !== prevProps.userPrivateMoney) {
      this.handleSelectMoney(this.props.userPrivateMoney);
    }
  }

  initForm = () => {
    this.setState({
      organizationOptions: [],
      selectedOrganizationOption: null,
      shopOptions: [],
      selectedShopOption: null
    })
    this.handleChangeShop(null);
  }

  handleSelectMoney = (money) => {
    const user = this.props.user;

    this.initForm();
    this.props.getQRDesign(toQueryParams({ private_money_id: money.id }));
    if (user.isServiceUser() || user.isIssuerOf(money.id)) {
      const query = `private_money_id=${money.id}&per_page=10000`;
      fetchOrganizations(query).then((members) => {
        const issuer = money.organization;
        const ops = members.rows.map(o => ({ label: o.name, value: o.code }));
        ops.push({ label: issuer.name, value: issuer.code });
        this.setState({ organizationOptions: ops });
      }).catch((err) => {
        // xxx: own money issuer gets 403 from the server. should be fixed
        const option = { label: user.organization.name, value: user.organization.code };
        this.setState({ organizationOptions: [option] });
        this.handleSelectOrganization(option);
      });
    } else {
      const option = { label: user.organization.name, value: user.organization.code };
      this.setState({ organizationOptions: [option] });
      this.handleSelectOrganization(option);
    }
  }

  handleSelectOrganization = (op) => {
    this.setState({ selectedOrganizationOption: op, selectedShopOption: null });
    this.handleChangeShop(null);
    const query = `organization_code=${op.value}&private_money_id=${this.props.userPrivateMoney.id}`;
    fetchShops(query).then((shops) => {
      this.setState({ shopOptions: shops.map(s => ({ label: s.name, value: s })) });
    });
  }

  handleSelectShop = (op) => {
    this.setState({ selectedShopOption: op });
    this.handleChangeShop(op.value);
  }

  getBillUrl() {
    const money = this.props.userPrivateMoney;
    const data = {
      private_money_id: money.id,
      user_id: this.props.shop.id,
      description: "",
      amount: null,
    };
    return createBill(data).then(bill => bill.token);
  }

  download = (size) => {
    const helper = new CanvasHelper();
    const [width, height] = SIZE_TABLE[size];
    const canvasSize = { width, height };
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    helper.canvas = canvas;
    this.getBillUrl().then((value) => {
      helper.withDraw(
        () => {
          helper.putBackgroundImage(this.props.background.image);
          helper.putQRImage(this.props.qrcode, { value, canvasSize });
          helper.putCaption(this.props.caption, { text: this.props.shop.name, canvasSize });
        }).then(() => {
          setTimeout(() => {
            const url = canvas.toDataURL();
            const link = document.getElementById("download-link");
            link.href = url;
            link.click();
          }, 0);
        });
    }).catch(() => {
      this.props.openAlertModal({
        body: (
          <span>{`${this.props.shop.name}の店舗のQRコードが取得できません`}</span>
        ),
        confirmText: "閉じる",
        useCancel: false,
      });
    });
  }

  handleChangeShop = (shop) => {
    this.props.setShop(shop);
  }

  draw = (helper) => {
    if (this.props.shop) {
      this.getBillUrl().then((value) => {
        helper.putQRImage(this.props.qrcode, { value });
        helper.drawImages();
      }).catch(() => {
        helper.drawImages();
      });
      helper.putCaption(this.props.caption, { text: this.props.shop.name });
    }
  }

  drawDummy = (helper) => {
    helper.clearCanvasObjects();
    helper.putBackgroundImage(null);
    helper.drawImages();
  }

  renderCanvas() {
    if (this.props.shop) {
      return (
        <QRCanvas
          draw={this.draw}
          background={this.props.background} />
      );
    } else {
      return (
        <div>
          <Message>
            <span>店舗が指定されていません</span>
          </Message>
          <QRCanvas
            draw={this.drawDummy}
            background={Object.assign({}, this.props.background, { image: null })} />
        </div>
      );
    }
  }

  renderDownloader() {
    return (
      <div>
        <LabeledSelect
          labelText={(<LabelText>組織</LabelText>)}
          options={this.state.organizationOptions}
          value={this.state.selectedOrganizationOption}
          onChange={this.handleSelectOrganization}
          placeholder="組織を選択して下さい"
        />
        <LabeledSelect
          labelText={(<LabelText>店舗</LabelText>)}
          options={this.state.shopOptions}
          value={this.state.selectedShopOption}
          onChange={this.handleSelectShop}
          placeholder="店舗を選択して下さい"
        />
        <div styleName="main">
          {this.renderCanvas()}
          <Picker download={this.download} canDownload={this.props.shop ? true : false} />
        </div>
        <a id="download-link" download="qr.png" styleName="hidden-link"></a>
        {this.props.user.isAllowedTo('write', 'QRDesign')
         ? <Button onClick={this.handleClick}>QRデザインの修正</Button>
         : null}
      </div>
    );
  }

  handleClick = (e) => {
    this.props.history.push('/settings/qr-designer');
  }

  renderUnfoundDescription() {
    if (this.props.user.isAllowedTo('write', 'QRDesign')) {
      return (
        <div>
          <div style={{ padding: '20px' }}>
            <div>店舗掲示用QRを表示するためのQRデザインが作られていません。</div>
            <div>表示するためにはQRデザインを作成してください。</div>
          </div>
          <div>
            <Button onClick={this.handleClick}>QRデザインの作成</Button>
          </div>
        </div>
      )
    } else {
      return (
        <div style={{ padding: '20px' }}>QRデザインを未登録のため、この機能は使用できません。</div>
      );
    }
  }

  renderUnauthorizedDescription() {
    return (
      <div style={{ padding: '20px' }}>
        選択中のマネーへの権限が不足しております。管理者へお問合せください
      </div>
    );
  }

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '販促管理', href: '', active: true },
      { value: '店舗掲示用QR', href: '', active: true },
    ];

    const { status } = this.props;

    return (
      <div>
        <Breadcrumb items={crumb} />
        <SelectedPrivateMoneyDisplay />
        {status === 'notFound' && this.renderUnfoundDescription()}
        {status === 'unauthorized' && this.renderUnauthorizedDescription()}
        {status === 'success' && this.renderDownloader()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  status: state.qrDesigner.status,
  qrcode: state.qrDesigner.qrcode,
  caption: state.qrDesigner.caption,
  background: {
    image: state.qrDesigner.backgroundImage,
    width: state.qrDesigner.size.width,
    height: state.qrDesigner.size.height,
  },
  shop: state.qrDesignViewer.shop,
  user: state.user,
  userPrivateMoney: state.userPrivateMoney.selectedMoney,
});

export default connect(mapStateToProps, {
  getQRDesign,
  openAlertModal,
  setShop,
})(CSSModules(ShopQRDesign, styles));
